import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Constants from '@/utils/Constants'
// import Utility from '@/utils/Utility'
import Validator from '@/utils/Validator'

export default {
  name: 'ServiceInput',
  data () {
    return {
      
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      categoryName: state => state.service.categoryName,

      // form
      userIdentity: state => state.serviceForm.targetId,
      values: state => state.serviceForm.values,

      // model
      tenantModel: state => state.serviceForm.tenantModel,
      communityModel: state => state.serviceForm.communityModel
    }),
    ...mapGetters({
      permittedView: 'permission/permittedView',
    }),

    // list
    tenantList () {
      let list = []
      this.tenantModel.forEach(item => list.push({
        value: item.tenant.tenantUuid,
        label: item.tenant.name
      }))
      return list
    },
    communityList () {
      let list = []
      this.communityModel.forEach(item => list.push({
        value: item.communityUuid,
        label: item.name
      }))
      return list
    },

    // input
    inpServiceName: {
      get () {
        return this.values.inpServiceName
      },
      set (value) {
        this.setInputValue({
          key: 'inpServiceName',
          value: value
        })
      }
    },
    inpTenant: {
      get () {
        return this.values.inpTenant
      },
      set (value) {
        this.setInputValue({
          key: 'inpTenant',
          value: value
        })
      }
    },
    inpCommunity: {
      get () {
        return this.values.inpCommunity
      },
      set (value) {
        this.setInputValue({
          key: 'inpCommunity',
          value: value
        })
      }
    },

    disabldeCommunity () {
      return !this.inpTenantIsValid
    },

    // validate
    inpServiceNameIsValid () {
      return Validator.validText(this.inpServiceName)
    },
    inpTenantIsValid () {
      return Validator.validText(this.inpTenant)
    },
    inpCommunityIsValid () {
      return Validator.validText(this.inpCommunity)
    },
    formIsValid () {
      return this.inpServiceNameIsValid &&
        this.inpTenantIsValid &&
        this.inpCommunityIsValid
    },
    disableConfirmButton () {
      return !this.formIsValid
    }
  },
  watch: {
    inpTenant (to) {
      let communityParams = {
        filters: {
          tenantUuid: to
        }
      }
      this.loadCommunityModel({
        communityParams: communityParams
      })
        .then(() => {
          console.log('i')
        })
        .catch(() => {
          console.log('e')
        })
    }
  },
  methods: {
    ...mapActions({
      loadCommunityModel: 'serviceForm/loadCommunityModel',
    }),
    ...mapMutations({
      setValues: 'serviceForm/setValues',
      setInputValue: 'serviceForm/setInputValue'
    }),

    init () {

    },
    turnBack () {
      this.$router.push({
        name: 'Service'
      })
    },

    confirmData () {
      if (!this.formIsValid) return

      // 確認画面に遷移
      this.$router.push({
        name: 'ServiceConfirm'
      })
    }
  }
}
